import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import {
	DARKORANGE,
	LIGHTERGRAY,
	PRIMARY_COLOR,
	WHITE,
	CLEARGRAY,
} from '../../../styles/colors.style'
import Button from '../../../components/buttons/buttons.component'

const Container = styled.section`
	background-color: ${LIGHTERGRAY};
	text-align: center;
	height: 100vh;

	.main {
		margin-left: auto;
		margin-right: auto;
		width: 90vw;
		padding: 4rem 0;

		h3 {
			color: ${PRIMARY_COLOR};
		}
		hr {
			max-width: 80%;
		}
	}
	.subcontainer {
		width: 90vw;
		background-color: ${CLEARGRAY};
		min-height: 250px;
		border-radius: 10px;
		max-width: 800px;
		margin-left: auto;
		margin-right: auto;

		.subcontainer-title {
			background-color: ${DARKORANGE};
			color: ${WHITE};
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			font-size: 2rem;
			font-weight: 600;
			padding: 10px;
		}
		.subcontainer-list-items {
			padding: 3%;
			text-align: left;
			font-size: 1.6rem;
			ul {
				list-style: none;
				li {
					margin-bottom: 12px;
				}
				li span {
					font-weight: 600;
					color: ${PRIMARY_COLOR};
				}
			}
		}
	}
	.close-button {
		width: 90vw !important;
		margin-left: auto;
		margin-right: auto;
		margin-top: 10px;
	}
`

class IntermunicipalInsurance extends Component {
	constructor() {
		super()
	}
	render() {
		return (
			<Container>
				<div className="main">
					<h3>Cobertura</h3>
					<hr />
					<p>
						Através da aquisição do seguro complementar, você terá mais
						proteção e segurança durante a sua viagem;
					</p>
					<p>
						Com este seguro, você tem direito a uma cobertura adicional,
						incluindo danos corporais e materiais, conforme demonstrado na
						apólice abaixo;
					</p>
				</div>
				<div className="subcontainer">
					<div className="subcontainer-title">
						Dados da Apolice de Seguro
					</div>
					<div className="subcontainer-list-items">
						<ul>
							<li>
								Morte por acidente: <span>R$ 64.775,00</span>
							</li>
							<li>
								Invalidez permanente por acidente:{' '}
								<span>R$ 64.775,00</span>
							</li>
							<li>
								Despesas médicas e hospitalares:{' '}
								<span>R$ 15.546,00</span>
							</li>
							<li>
								Seguradora: <span>ESSOR SEGUROS S.A.</span>
							</li>
							<li>
								Numero da apólice: <span>1002806279620</span>
							</li>
							<li>
								Informações: <span>0800 777 0438</span>
							</li>
						</ul>
					</div>
				</div>
				<div className="close-button">
					<Button primary onClick={() => window.close()}>
						Fechar
					</Button>
				</div>
			</Container>
		)
	}
}

const connectedLaunch = withRouter(connect(null)(IntermunicipalInsurance))
export { connectedLaunch as ModuleRootComponent }
